import * as yup from 'yup';
import { hasAmbulantSelected } from '@/features/Sparten/pkv/formConfigs/sharedRenderConditions';
import { beitragsentlastungOptionenSchema } from '@/features/Sparten/pkv/schema/beitragsentlastungOptionenSchema/beitragsentlastungOptionenSchema';
import { getFirstOfNextMonth } from '@/utils/dates/dates';

export const allgemeinSchema = yup.object({
  versicherungsbeginn: yup.date().default(getFirstOfNextMonth()).required(),
  selbstbeteiligungMin: yup.number().default(0).min(0),
  selbstbeteiligungMax: yup
    .number()
    .default(600)
    .when({
      is: () => hasAmbulantSelected(),
      then: yup.number().required(),
    }),
  optionsrecht: yup.boolean().default(false),
  beitragsrueckerstattung: yup.string().default(''),
  pauschalleistung: yup.string().default(''),
  primaerarzttarif: yup.boolean().default(false),
  osttarife: yup.boolean().default(false),
  beitragsentlastungOptionen: beitragsentlastungOptionenSchema,
  altersrueckstellung: yup.string().default(''),
});
